module.exports = __webpack_public_path__ + "static/img/fullscreen-image_hero_600.bf8a1e5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/blog/fullscreen-image_hero_600.png
// module id = nRjS
// module chunks = 0